import React from 'react';
import './Policies.css';

const ConsentPolicy: React.FC = () => {
    return (
        <div className="terms-container">
            <section className="consent-section">
                <h2 className="section-title">1. Consent Policy</h2>

                <div className="content-block">
                    <h3 className="sub-title">1.1 User Consent</h3>
                    <p className="mt-2">
                        By using DateNow, you provide informed and explicit consent for the following:
                    </p>
                    <ul className="list">
                        <li>
                            The collection, use, and processing of your personal data in accordance with our{' '}
                            <a href="#privacy-policy" className="link">Privacy Policy</a>.
                        </li>
                        <li>
                            Permission to access device features (e.g., location, camera, microphone) as required for
                            specific features, with clear in-app prompts.
                        </li>
                        <li>
                            Receiving communications from DateNow, including service-related updates and optional
                            promotional content. Users may opt out of promotional messages anytime.
                        </li>
                        <li>
                            Sharing select profile information with matched users for the purpose of facilitating
                            interactions and meaningful connections.
                        </li>
                        <li>
                            Participation in analytics and performance monitoring tools (e.g., Firebase, Crashlytics)
                            that help improve app stability and experience.
                        </li>
                    </ul>
                </div>

                <div className="content-block">
                    <h3 className="sub-title">1.2 Withdrawal of Consent</h3>
                    <p className="mt-2">
                        You may withdraw consent at any time using the following methods:
                    </p>
                    <ul className="list">
                        <li>
                            By deleting your account via in-app settings, which will erase all personal data associated
                            with your profile.
                        </li>
                        <li>
                            By modifying permissions in your device settings (e.g., turning off location or camera
                            access).
                        </li>
                        <li>
                            By opting out of promotional communications through unsubscribe links or settings.
                        </li>
                        <li>
                            By contacting our support team at{' '}
                            <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>{' '}
                            for specific data removal or policy inquiries.
                        </li>
                    </ul>
                    <p className="mt-2">
                        Please note that revoking certain permissions may limit access to some app features.
                    </p>
                </div>
            </section>

            {/* Updates to These Policies Section */}
            <section className="updates-section">
                <h2 className="section-title">Updates to These Policies</h2>

                <div className="content-block">
                    <p className="mt-2">
                        We reserve the right to update these policies at any time.
                    </p>
                    <ul className="list">
                        <li>Significant changes will be communicated to users via the app and/or email.</li>
                        <li>Continued use of DateNow after changes constitutes acceptance of the new policies.</li>
                    </ul>
                </div>
            </section>

            {/* Contact Section */}
            <section className="contact-section">
                <h2 className="section-title">Contact Us</h2>
                <div className="content-block">
                    <p className="mt-2">For any questions, concerns, or feedback, please contact us at:</p>
                    <p className="mt-2">
                        📧 Email: <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>
                    </p>
                </div>
            </section>
        </div>
    );
};

export default ConsentPolicy;